import React, { useState, useEffect } from 'react';
import { api } from '../../api/api';

const AppointmentForm = () => {
  const [formData, setFormData] = useState({
    coachId: '',
    projectId: '',
    xiangmuleixing: '',
    xiangmumingcheng: '',
    appointmentDate: '',
    appointmentTime: '',
    duration: 60,
    paymentMethod: 1, // 默认在线支付
    remark: ''
  });

  const [coaches, setCoaches] = useState([]);
  const [projects, setProjects] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);

  // 获取项目列表
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await api.get('/jianshenxiangmu/list?page=1&limit=1000');
        if (response.data && response.data.code === 0) {
          setProjects(response.data.data.list || []);
        }
      } catch (error) {
        console.error('获取项目列表失败:', error);
      }
    };

    const fetchCoaches = async () => {
      try {
        const response = await api.get('/jiaolian/list?page=1&limit=1000');
        if (response.data && response.data.code === 0) {
          setCoaches(response.data.data.list || []);
        }
      } catch (error) {
        console.error('获取教练列表失败:', error);
      }
    };

    fetchProjects();
    fetchCoaches();
  }, []);

  // 处理项目选择变化
  const handleProjectChange = (projectId) => {
    const selectedProject = projects.find(p => p.id == projectId);
    if (selectedProject) {
      setFormData({
        ...formData,
        projectId: projectId,
        xiangmuleixing: selectedProject.xiangmuleixing || '',
        xiangmumingcheng: selectedProject.xiangmumingcheng || '',
        duration: selectedProject.durationMinutes || 60
      });
    } else {
      setFormData({
        ...formData,
        projectId: '',
        xiangmuleixing: '',
        xiangmumingcheng: '',
        duration: 60
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // 构建提交数据
      const submitData = {
        ...formData,
        yuyueshijian: `${formData.appointmentDate} ${formData.appointmentTime}:00`,
        startTime: `${formData.appointmentDate} ${formData.appointmentTime}:00`,
        yuyueshuoming: formData.remark
      };

      const response = await api.post('/jiaolianyuyue/save', submitData);
      
      if (response.data && response.data.code === 0) {
        alert('预约提交成功！');
        // 重置表单或跳转到其他页面
      } else {
        alert('预约提交失败：' + (response.data.msg || '未知错误'));
      }
    } catch (error) {
      console.error('提交预约失败:', error);
      alert('预约提交失败，请稍后重试');
    }
  };

  return (
    <div className="appointment-form">
      <h2>预约教练</h2>
      <form onSubmit={handleSubmit}>
        {/* 教练选择 */}
        <div className="form-group">
          <label>选择教练</label>
          <select 
            value={formData.coachId}
            onChange={(e) => setFormData({...formData, coachId: e.target.value})}
            required
          >
            <option value="">请选择教练</option>
            {coaches.map(coach => (
              <option key={coach.id} value={coach.id}>
                {coach.jiaolianxingming} ({coach.jiaolianbianhao})
              </option>
            ))}
          </select>
        </div>

        {/* 项目选择 */}
        <div className="form-group">
          <label>选择健身项目</label>
          <select
            value={formData.projectId}
            onChange={(e) => handleProjectChange(e.target.value)}
            required
          >
            <option value="">请选择健身项目</option>
            {projects.map(project => (
              <option key={project.id} value={project.id}>
                {project.xiangmumingcheng} - {project.xiangmuleixing} - ¥{project.jiage}
              </option>
            ))}
          </select>
        </div>

        {/* 日期选择 */}
        <div className="form-group">
          <label>选择日期</label>
          <input
            type="date"
            value={formData.appointmentDate}
            onChange={(e) => setFormData({...formData, appointmentDate: e.target.value})}
            min={new Date().toISOString().split('T')[0]}
            required
          />
        </div>

        {/* 时间选择 */}
        <div className="form-group">
          <label>选择时间</label>
          <select
            value={formData.appointmentTime}
            onChange={(e) => setFormData({...formData, appointmentTime: e.target.value})}
            required
          >
            <option value="">请选择时间</option>
            {timeSlots.map(slot => (
              <option key={slot} value={slot}>{slot}</option>
            ))}
          </select>
        </div>

        {/* 时长选择 */}
        <div className="form-group">
          <label>预约时长</label>
          <select
            value={formData.duration}
            onChange={(e) => setFormData({...formData, duration: parseInt(e.target.value)})}
            required
          >
            <option value={60}>1小时</option>
            <option value={90}>1.5小时</option>
            <option value={120}>2小时</option>
          </select>
        </div>

        {/* 支付方式选择 */}
        <div className="form-group">
          <label>支付方式</label>
          <div className="payment-methods">
            <label className="payment-method">
              <input
                type="radio"
                name="paymentMethod"
                value={1}
                checked={formData.paymentMethod === 1}
                onChange={(e) => setFormData({...formData, paymentMethod: parseInt(e.target.value)})}
              />
              <span>在线支付</span>
            </label>
            <label className="payment-method">
              <input
                type="radio"
                name="paymentMethod"
                value={2}
                checked={formData.paymentMethod === 2}
                onChange={(e) => setFormData({...formData, paymentMethod: parseInt(e.target.value)})}
              />
              <span>到店付款</span>
            </label>
          </div>
        </div>

        {/* 备注信息 */}
        <div className="form-group">
          <label>备注信息</label>
          <textarea
            value={formData.remark}
            onChange={(e) => setFormData({...formData, remark: e.target.value})}
            placeholder="请输入备注信息（选填）"
          />
        </div>

        <button type="submit" className="submit-btn">
          提交预约
        </button>
      </form>
    </div>
  );
};

export default AppointmentForm; 